<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:31:16
--> 
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-col cols="12">
          <!-- filter:状态码   状态：0准备入职   1试用   2准备转正   3在职   4停职   5准备离职   6离职   7退休  -->
          <!-- :errMsg="$errors('list','apply_staff_uuid',requiredRule)" -->
          <!-- :disabled="$store.state.uuid?true:false" -->
          <!-- :backgroundColor="disabled?'':'rgb(245, 245, 245)'" -->
          <mrc_ess_staffInfo
            v-model="list.apply_staff_uuid"
            defaultRequest
            :errorMessages="$errors('list', 'apply_staff_uuid', requiredRule)"
            filter="5,6"
            :label="this.$t('label_A_departing_employee') + '*'"
            @changeStaffList="changeList"
            :readonly="disabled"
          ></mrc_ess_staffInfo>
        </v-col>
        <v-col cols="12">
          <!-- :notfilter='list.apply_staff_uuid' -->
          <!-- :errMsg="$errors('list','handover_staff_uuid',requiredRule)" -->
          <mrc_ess_staffInfo
            v-model="list.handover_staff_uuid"
            defaultRequest
            filter="1,2,3,5,0"
            :errorMessages="
              $errors('list', 'handover_staff_uuid', requiredRule)
            "
            ref="handover_staff_uuid"
            :label="this.$t('label_Take_over') + '*'"
            :readonly="disabled"
          ></mrc_ess_staffInfo>
        </v-col>
        <div>
          <v-col cols="12">
            <!-- :errMsg="$errors('list','handover_date',requiredRule)" -->
            <mrc_ess_datePicker
              @getTime="paramsChange"
              afterDate
              :errMsg="$errors('list', 'handover_date', requiredRule)"
              :disabled="disabled"
              :label="$t('label_Handover_time') + '*'"
              v-model="list.handover_date"
            ></mrc_ess_datePicker>
          </v-col>
          <!-- <v-col cols="12">
          <mrc_ess_datePicker @getTime='paramsChange'
                              :disabled="disabled"
                              :errMsg="$errors('list','change_effective',requiredRule)"
                              :label="$t('交接生效时间')"
                              v-model="list.change_effective"></mrc_ess_datePicker>
        </v-col> -->
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_Handover_content')"
              noRequired
              :error-messages="$errors('list', 'handover_detail', nocharacter)"
              :isNational="judegNational('handover_detail')"
              v-model="list.handover_detail"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_bulkFile
              v-model="file"
              v-if="!disabled"
              @changeFile="changeFile"
            ></mrc_ess_bulkFile>
          </v-col>
          <v-col cols="12">
            <div
              v-for="(item, index) in viewFormDate"
              class="d-flex justify-space-between align-center"
              :key="index"
            >
              <div>
                <mrc_ess_svgIcon
                  :iconClass="'filetype-' + suffix(item.name)"
                  style="font-size: 23px"
                />
                <span class="mx-1">{{ item.name }}</span>
                <span>({{ item.size }}KB)</span>
              </div>
              <div v-show="!disabled">
                <v-icon
                  class="material-icons"
                  @click="deleteviewfile(item, index)"
                  style="font-size: 28px"
                  >delete</v-icon
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div
              v-for="(item, index) in fileInfo"
              :key="index"
              class="d-flex justify-space-between align-center"
            >
              <div>
                <mrc_ess_svgIcon
                  :iconClass="'filetype-' + suffix(item.name)"
                  style="font-size: 23px"
                />
                <span class="mx-1">{{ item.name }}</span>
                <span>({{ item.size }}KB)</span>
              </div>
              <div v-show="!disabled">
                <v-icon
                  class="material-icons"
                  @click="download(item, index)"
                  style="font-size: 28px"
                  >arrow_downward</v-icon
                >
                <v-icon
                  class="material-icons"
                  @click="deletefile(item, index)"
                  style="font-size: 28px"
                  >delete</v-icon
                >
              </div>
            </div>
          </v-col>
        </div>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getHandoverList,
  addHandover,
  updateHandover,
  deleteHandover,
  detailHandover,
} from "@/service/api/staffmsg.js";
import { findSrc } from "@/service/api/upload.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      file: null,
      viewFormDate: [],
      fileInfo: [],
      formData: [],
      list: {},
      btnIsLoading: false,
      viewList: {},
      delete_attachments: [],
      urlList: [],
    };
  },
  computed: {
    company_uuid() {
      //当前选中公司uuid
      return this.$store.state.currentCompany;
    },
    turnover_person() {
      return { prompt_name: "turnover_person" };
    },
  },
  created() {},
  watch: {},
  async mounted() {
    let formData = new FormData();
    this.formData = formData;
    this.national("mrbase_sys_staff_termination");
    if (this.$store.state.uuid) {
      this.getDetail();
    } else {
      this.skeletonloading = false;
    }
  },

  methods: {
    download(val) {
      const links = document.createElement("a");
      // let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      links.style.display = "none";
      //设置连接
      links.href = val.path;
      links.download = val.name;
      document.body.appendChild(links);
      //模拟点击事件
      links.click();
      document.body.removeChild(links);
    },
    deletefile(val, index) {
      this.fileInfo.splice(index, 1);
      this.delete_attachments.push(val);
    },
    deleteviewfile(val, index) {
      // console.log(val);
      this.viewFormDate.splice(index, 1);
      // console.log(this.formData);
    },
    suffix(val) {
      return val.slice(val.indexOf(".") + 1);
    },
    changeFile(v) {
      this.viewFormDate.push(v);
      // this.formData.append('file', v)
      // this.viewFormDate = this.formData.getAll("file")
    },
    paramsChange() {},
    changeList(val) {
      // this.$refs.handover_staff_uuid.getSelectList()
      // this.viewList = val
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailHandover({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
        if (this.list.attachment) {
          await findSrc({ uuid: this.list.attachment }).then((res) => {
            if (res.data.files.length > 0) {
              this.fileInfo = res.data.files;
            } else {
              this.fileInfo = [];
            }
          });
        }
      } else {
      }
      this.skeletonloading = false;
    },
    async uploadFilesMore() {
      let fileuuids = [];
      for (let i = 0; i < this.viewFormDate.length; i++) {
        const res = await this.$uploadFiles([this.viewFormDate[i]], {
          module_uuid:'staff',
          function_uuid: this.$store.state.menuFunctionUuid,
          attachment_data_table: "mrbase_sys_staff_termination",
          attachment_data_field: "attachment",
          org_level_uuid: this.$store.state.currentCompany,
          uuid: this.$store.state.currentCompanyClientUuid,
        });
        if (typeof res == "object" && res != undefined && res.code == 200) {
          fileuuids.push(res.uuid);
          this.urlList.push(res.uuid);
        }
      }
      return fileuuids;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.btnIsLoading = true;
      if (this.$store.state.uuid) {
        // 删除文件  处理
        let deleteFileUuidArr = [];
        this.delete_attachments.forEach((item) => {
          deleteFileUuidArr.push(item.uuid);
        });
        let deleteFileUuid = deleteFileUuidArr.join();
        // 上传文件\
        let fileuuids = await this.uploadFilesMore();
        fileuuids = fileuuids.join();
        // 处理上传文件逻辑，判断文件是删除，新增
        this.list.attachment =
          this.list.attachment != "" ? this.list.attachment.split(",") : [];
        let arr = [];
        this.list.attachment.forEach((item, index) => {
          let isno = true;
          deleteFileUuidArr.forEach((item1) => {
            // console.log(item, item1, item == item1);
            if (item == item1) {
              isno = false;
              return;
            }
          });
          if (isno) {
            arr.push(item);
          }
        });
        this.list.attachment = this.$clone(arr);
        if (!fileuuids == "") {
          this.list.attachment = this.list.attachment.join()
            ? this.list.attachment.join() + "," + fileuuids
            : fileuuids;
        } else {
          this.list.attachment = this.list.attachment.join();
        }
        // console.log(this.list.attachment, deleteFileUuid);
        // return
        // await this.$uploadFilesMore(this.viewFormDate, {
          // module_uuid:'staff',
          //   function_uuid: this.$store.state.menuFunctionUuid,
        //   attachment_data_table: 'mrbase_sys_staff_termination',
        //   attachment_data_field: 'attachment',
        //   org_level_uuid: this.$store.state.currentCompany,
        //   uuid: this.$store.state.currentCompanyClientUuid,
        //   staff_uuid: this.list.apply_staff_uuid + ',' + this.list.handover_staff_uuid
        // })
        String(this.list.handover_date).indexOf("-") != -1
          ? (this.list.handover_date = this.$moment(this.list.handover_date))
          : "";
        const res = await updateHandover({
          ...this.$deletefield(null, this.list),
          delete_attachments: deleteFileUuid,
        });
        if (res.code == 200) {
          this.delete_attachments.forEach((item) => {
            this.$deleteFile(item.uuid);
            deleteFileUuidArr.push(item.uuid);
          });
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          // await this.getDetail()
        } else {
          this.urlList.forEach((itemm) => {
            this.$deleteFile(item);
          });
        }
        this.delete_attachments = [];
        this.viewFormDate = [];
        this.delete_attachments = [];
        this.urlList = [];
        this.btnIsLoading = false;
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        // const res = await addHandover(this.list)
        // if (res.code == 200) {
        //   await this.$uploadFilesMore(this.formData.getAll("file"), {
          // module_uuid:'staff',
          //     function_uuid: this.$store.state.menuFunctionUuid,
        //     attachment_data_table: 'mrbase_sys_staff_termination',
        //     attachment_data_field: 'attachment',
        //     org_level_uuid: this.$store.state.currentCompany,
        //     uuid: this.$store.state.currentCompanyClientUuid,
        //     staff_uuid: this.list.apply_staff_uuid + ',' + this.list.handover_staff_uuid
        //   })
        //   this.$Message({ text: this.$t('message_added_successfully') })
        //   this.$router.push({ name: 'staffConnect' })
        // }
      }
      this.btnIsLoading = false;
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staffConnect",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      apply_staff_uuid: {
        required,
      },
      handover_staff_uuid: {
        required,
      },
      handover_date: {
        required,
      },
      handover_detail: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      // change_effective: {
      //   required
      // }
    },
  },
};
</script>

<style scoped>
</style>

